module.exports = __webpack_public_path__ + "static/Service-Rectangle-2-591a99c0d7d799622acc500d27d3b3ed.png";